<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="우리말 해석을 보고 영어 문장을 완성합니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="lg:p-8 md:p-6 sm:p-4 p-4 rounded-lg mb-base text-center">
        <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
          <p class="sentence text-primary">{{content.translation}}</p>            
        </vs-row>
      </div> 
      <vs-divider></vs-divider>
      <div class="lg:p-8 md:p-6 sm:p-4 p-4 rounded-lg mb-base text-center">
        <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
            <component 
              v-model="item.model" 
              :ref="item.ref" 
              @onEnter="onChildEnter"
              @onBack="onChildBack" 
              :key="index" 
              v-for="(item, index) in sentenceComponentList" 
              :is="item.input" 
              v-bind="item.props"/>
        </vs-row>
      </div>  
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>

</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
import DictationWordInput      from './DictationWordInput.vue'
import DictationWordLabel      from './DictationWordLabel.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    DictationWordInput,
    DictationWordLabel
  },
  data () {
    return {
      sentenceComponentList: [],
      dictationInputList: [],
      contentList: [],
      contentsLen: 0,
      hint: true,
      contentIndex: 0,
      finished: false,
      retryCount: 0
    }
  },
  watch: {
    sourceContent () {
      this.contentList = []
      this.parseContent()
      this.onReload()
    }
  },
  computed: {
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    },
    sentenceWords () {
      return this.content.sentence.split(' ')
    },
    dictationWords () {
      return this.content.dictation.split(' ')
    }
  },
  methods: {
    onReload () {
      this.hint = false
      this.contentIndex = 0
      this.hintUseNum = 0
      this.retryCount = 0
      this.studyResult = []
      this.resetComponents()
      this.startAlert()
    },
    onStart () {
      this.configSentence()
    },
    onHint () {
      if (this.hintUseNum >= this.hintCount) {
        this.finishHintDlg()
      } else {
        this.hintUseNum++
        for (let i = 0; i < this.dictationInputList.length; i++) {
          this.dictationInputList[i].props.hint = true
        }
      }
    },
    resetComponents () {
      this.sentenceComponentList = []
      this.dictationInputList = []
    },
    startAlert () {
      this.startStudyDlg('우리말 해석을 보고 영어 문장을 완성합니다.')
    },
    acceptAlert () {
      this.onStart()
    },
    replaceSymbol (value) {
      return value.replace('.', '').replace('?', '').replace('!', '').replace(',', '')
    },
    configSentence () {
      
      let inputIndex = 0
      for (let i = 0; i < this.dictationWords.length; i++) {
        if (this.dictationWords[i].substring(0, 1) !== '_') {
          const conf = {
            data: this.sentenceWords[i]
          }
          const comp = {
            input: DictationWordLabel, 
            props: conf, 
            model: this.replaceSymbol(this.sentenceWords[i]),
            answer: this.replaceSymbol(this.sentenceWords[i])
          }
          this.sentenceComponentList.push(comp)
        } else { 
          
          // 마침표, 물음표 등 특수기호 처리
          const sen = this.sentenceWords[i]
          let hasSymbol = false
          const symbol = sen.substring(sen.length - 1, sen.length)
          if (symbol === '.' || symbol === '?' || symbol === '!' || symbol === ',') {
            hasSymbol = true
          }

          const conf = {
            hintValue: this.replaceSymbol(this.sentenceWords[i]),
            hint: false,
            index: inputIndex
          }
          const comp = {
            input: DictationWordInput, 
            props: conf, 
            model: '',
            value: '',
            answer:  this.replaceSymbol(this.sentenceWords[i]), 
            ref: `input_${inputIndex}`
          }
          this.sentenceComponentList.push(comp)  
          this.dictationInputList.push(comp)

          if (hasSymbol) {
            this.sentenceComponentList.push({ input: DictationWordLabel, props: {data: symbol}})
          }

          inputIndex++
        }
      }

      setTimeout(function () {
        this.$refs['input_0'][0].focus()
      }.bind(this), 500)

    },
    checkAnswer () {
      let correct = true
      for (let i = 0; i < this.dictationInputList.length; i++) {
        if (this.dictationInputList[i].model !== this.dictationInputList[i].answer) {
          correct = false
          break
        }
      }
      return correct
    },
    onChildEnter (index) {
      
      if (this.dictationInputList[index].model.length === 0) {
        return
      }

      if (index < this.dictationInputList.length - 1) {
        this.$refs[`input_${  index + 1  }`][0].focus()
      } else {
        
        // let correct = true
        // for (let i = 0; i < this.dictationInputList.length; i++) {
        //   console.log(this.dictationInputList[i].model)
        //   console.log(this.dictationInputList[i].answer)
        //   if (this.dictationInputList[i].model !== this.dictationInputList[i].answer) {
        //     correct = false
        //     break
        //   }
        // }

        if (this.checkAnswer()) {
          this.correct()
        } else {
          
          this.inCorrect()
          this.retryCount++
          if (this.retryCount < this.retry) {
            setTimeout(function () {
              for (let i = 0; i < this.dictationInputList.length; i++) {
                this.dictationInputList[i].model = ''
              }
            }.bind(this), 1500)
            return
          }
        }

        //this.addResult(this.dictationInputList[index].answer, this.dictationInputList[index].model) 
        //this.audioPlayer.pause()

        if (this.contentIndex < this.contentsLen - 1) {
          setTimeout(function () {
            this.retryCount = 0
            this.contentIndex++
            this.resetComponents()
            this.configSentence()
          }.bind(this), 1500)
        } else {
          this.onComplete()   
        }  
      }
    },
    onChildBack (index) {
      if (index !== 0 && this.dictationInputList[index].model.length === 0) {
        this.$refs[`input_${  index - 1  }`][0].focus()
      }
    },
    parseContent () {

      const contentJson = JSON.parse(this.sourceContent.contentBody)

      for (let i = 0; i < contentJson.sentence.length; i++) {
        const content = {
          sentence: contentJson.sentence[i],
          translation: contentJson.translation[i],
          dictation: contentJson.dictation[i]
        } 
        this.contentList.push(content)
      }
      this.contentsLen = this.contentList.length
    }
  },
  
  created () {

    this.parseContent()
    this.startAlert()
    
  },
  mounted () {
    
  }
}

</script>
